/* eslint-disable max-len */
import React from 'react'

import { string } from 'prop-types'

function FreeItem(props) {
  return (
    <svg
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.87769 1.68758C8.6997 1.7809 9.45813 2.17586 10.0046 2.79695C10.3166 2.44181 10.7008 2.15751 11.1316 1.96297C11.5626 1.76836 12.0307 1.66804 12.5037 1.66902L12.7234 1.67586C13.2321 1.70937 13.7274 1.85948 14.1707 2.11531C14.6774 2.40788 15.0988 2.82929 15.3914 3.33601C15.6837 3.84256 15.8376 4.41717 15.8376 5.00203C15.8376 5.5871 15.6839 6.16233 15.3914 6.66902H18.3376V8.33601H17.5046V16.669C17.5046 16.8899 17.4166 17.1016 17.2605 17.2579C17.1042 17.4142 16.8917 17.502 16.6707 17.502H3.33765C3.11664 17.502 2.90505 17.4142 2.74878 17.2579C2.59251 17.1016 2.50465 16.89 2.50464 16.669V8.33601H1.67065V6.66902H4.61694C4.20258 5.95308 4.06935 5.10866 4.24292 4.29988C4.4166 3.49099 4.88456 2.77488 5.5564 2.29207C6.2282 1.8093 7.05569 1.59428 7.87769 1.68758ZM9.17065 16.669H10.8367V8.33601H9.17065V16.669ZM7.50366 3.33601C7.07315 3.33703 6.65909 3.50379 6.34937 3.80281C6.03971 4.10178 5.85776 4.50941 5.84155 4.93953C5.8254 5.36974 5.977 5.78999 6.26343 6.1114C6.54984 6.43266 6.94955 6.63084 7.37866 6.66414L7.50366 6.66902H9.17065V5.00203C9.1706 4.60397 9.02751 4.21917 8.76831 3.91707C8.5089 3.61485 8.1493 3.41491 7.75562 3.35457L7.62769 3.33992L7.50366 3.33601ZM12.5037 3.33601C12.0832 3.33588 11.6782 3.49446 11.3699 3.78035C11.0616 4.0662 10.8722 4.45783 10.8406 4.87703L10.8367 5.00203V6.66902H12.5037C12.9239 6.66891 13.3284 6.50956 13.6365 6.22371C13.9446 5.93782 14.1333 5.54616 14.1648 5.12703L14.1707 5.00203C14.1706 4.5603 13.9946 4.13675 13.6824 3.82429C13.3698 3.51177 12.9456 3.33605 12.5037 3.33601Z"
        fill="#35424F"
      />
    </svg>
  )
}

FreeItem.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default FreeItem
